// extracted by mini-css-extract-plugin
module.exports = {"selectedGroupItemLabel":"SiblingProductOptions_selectedGroupItemLabel__yrkdn"};